import { Component, OnInit, OnDestroy, AfterViewInit, ElementRef, ViewChild } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { SeguridadService } from '../_services/seguridad.service'
import { Subscription } from 'rxjs/Subscription';

import { PreguntasService } from '../_services/preguntas.service';

import { GlobalEventsManager } from "../_services/globaleventsmanager.service";
import { NormasService } from '../_services/normas.service';
import { EmpresasService } from '../_services/empresas.service';

import { Usuario } from '../_models/usuario.model';


declare var jQuery: any;

@Component({
    selector: 'empresas',
    templateUrl: 'empresas.template.html'
})
export class EmpresasComponent implements OnInit, OnDestroy, AfterViewInit {

  subscription: Subscription;
  public filterQuery = "";
  public filterQueryEvidencias = "";

  listaempresas: any=[];

  constructor(private seguridad: SeguridadService,
      private router: Router,
      private normasService: NormasService,
      private empresasService: EmpresasService,
      private globalEventsManager: GlobalEventsManager,
      private activatedRoute: ActivatedRoute) {


  }

  ngOnInit() {

    this.seguridad.getLogado();

    this.subscription = this.seguridad.dejoPasarUsuarioEmitter.subscribe((mode) => {
        if (mode !== null) {
            if (!mode) {
                this.router.navigate(['login']);
            }
        }
    });

    this.globalEventsManager.menuExtendido(true);


    let breadcrumb: any = [
      {
        'path':'#',
        'name': 'Administración de empresas'
      }];

    this.globalEventsManager.setNombrePagina(breadcrumb);

    this.getListaEmpresas();

  }

  ngAfterViewInit() {

  }

  ngOnDestroy() {
    this.subscription.unsubscribe();
  }

  getListaEmpresas(){
    this.empresasService.getListaEmpresas().subscribe(
        data => {
          if (data){

            this.listaempresas = data.json().lista;
            console.log(this.listaempresas);
          }
        }
    );
  }


  stripText(val: string, limite: number){
    var cadena: string = "";

    if (val != null){
      if (val.length>limite){
        cadena = val.substr(0, limite)+"...";
      }else{
        cadena = val;
      }
    }

    return cadena;
  }

  verEmpresa(id_empresa:number){
    this.router.navigate(['empresas',id_empresa]);
  }

}



// WEBPACK FOOTER //
// ./src/app/empresas/empresas.component.ts